import useMutation from "src/hooks/useMutation";

function useWTRemove(id) {
  const path = !!id
    ? `/api/v1/warehouse-transfers/${id}`
    : `/api/v1/warehouse-transfers/id`;
  return useMutation({
    path: path,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouse-transfers`,
      shouldRevalidate: true,
    },
  });
}

export default useWTRemove;
